<script>
import { mapGetters } from 'vuex';
export default {
  name: 'ProcessDataProvider',
  props: {
    processId: {
      type: String,
      default: '0'
    },
    originalId: {
      type: String,
      default: '0'
    },
    category: {
      type: String,
      default: '0'
    }
  },
  computed: {
    hasChangelogReminder() {
      if (this.remindChangelogForProcessIds.length < 1) {
        return false;
      }
      return this.remindChangelogForProcessIds.includes(this.dataId);
    },
    ...mapGetters('processes', {
      process: 'process',
      loading: 'loading',
      originalProcess: 'originalProcess',
      error: 'error',
      remindChangelogForProcessIds: 'remindChangelogForProcessIds'
    })
  },
  data() {
    return {
      dataId: '0',
      success: false,
      mode: 'view',
      category: ''
    };
  },
  methods: {
    create({ name, description, category }) {
      this.$store
        .dispatch('processes/createProcess', {
          name: name,
          description: description,
          category: category,
          visibility: this.$can('manage', 'ProcessTemplate')
            ? 'Public'
            : 'Private'
        })
        .then(id => {
          this.dataId = id;
          this.$router.push({
            name: 'process',
            params: {
              id: id
            }
          });
          this.mode = 'view';
        });
    },
    edit({ id, name, description }) {
      this.$store.dispatch('processes/editProcess', {
        id: id,
        name: name,
        description: description
      });
    },
    publish({ id }) {
      this.$store.dispatch('processes/publishProcess', {
        id: id
      });
    },
    unpublish({ id }) {
      this.$store.dispatch('processes/unpublishProcess', {
        id: id
      });
    },
    customize({ id }) {
      this.$store
        .dispatch('processes/customizeProcess', {
          id: id
        })
        .then(id => {
          this.$router.push({
            params: {
              id: id
            }
          });
        });
    },
    delete({ id }) {
      this.$store
        .dispatch('processes/deleteProcess', {
          id: id
        })
        .then(() => {
          this.$router.push({
            path: '/'
          });
        });
    },
    tabSwitched(tab) {
    },
    logReadConsent() {
      let process = this.process(this.dataId);
      if (process && process.notifications.length > 0) {
        this.markAsRead(this.dataId);
      }
    },
    markAsRead(id) {
      this.$store.dispatch('processes/markAsRead', {
        id: id
      });
    },
    removeProcessIdRemindChangelog({ id }) {
      this.$store.dispatch('processes/removeProcessIdRemindChangelog', {
        id: id
      });
    }
  },
  render() {
    if (!this.$scopedSlots.default) {
      return;
    }

    const slotScope = {
      process: this.process(this.dataId),
      originalProcess: this.originalProcess(this.dataId),
      create: this.create,
      edit: this.edit,
      publish: this.publish,
      unpublish: this.unpublish,
      success: this.success,
      mode: this.mode,
      category: this.category,
      customize: this.customize,
      delete: this.delete,
      loading: this.loading,
      routeParams: this.$route.params,
      tabSwitched: this.tabSwitched,
      error: this.error,
      hasChangelogReminder: this.hasChangelogReminder,
      removeProcessIdRemindChangelog: this.removeProcessIdRemindChangelog
    };

    return this.$scopedSlots.default(slotScope);
  },
  created() {
    if (this.originalId && this.originalId !== '0') {
      this.mode = 'view';
      this.dataId = this.originalId;
    } else if (this.processId !== '0') {
      this.mode = 'view';
      this.dataId = this.processId;
    } else {
      this.mode = 'create';
      this.category = this.category;
    }
    if (this.dataId !== '0') {
      var hasAccess = this.$can('read', 'ProcessTemplate');

      this.$store
        .dispatch('processes/fetchProcess', { id: this.dataId, hasAccess })
        .then(() => {
          this.success = true;
        });
    }
  }
};
</script>
